export default {
  namespaced: true,
  state: {
    component: "",
  },
  actions: {
    setComponentName({ commit, dispatch }, name) {
      //* Compoenet needs to register inside the UiModal first
      commit("SET_COMPONENT_NAME", name);

      // * Triger tracking for Renew, Invoice and other modals
      switch (name) {
        case "invoice":
          dispatch("purl/purlTracking", "View Invoice", { root: true });
          break;
        // case "renew":
        //   name = "Renew Now";
        //   break;

        default:
          return;
      }
    },
    setVideoIsPalying({ commit }, isPlaying) {
      commit("SET_VIDEO_IS_PLAYING", isPlaying);
    },
    setVideoId({ commit }, videoId) {
      commit("SET_VIDEO_ID", videoId);
    },
  },
  mutations: {
    SET_COMPONENT_NAME(state, name) {
      state.component = name;
    },
    SET_VIDEO_IS_PLAYING(state, isPlaying) {
      state.videoIsPlaying = isPlaying;
    },
    SET_VIDEO_ID(state, videoId) {
      state.videoId = videoId;
    },
  },

  getters: {},
};
